import { apiClient } from '~api/client';
import type { DrilledDataQueryParams, DrilledDataResponse } from './drilled-data.types';

/**
 * Drilled Data service for accessing actual drill hole data
 */
const drilledDataService = {
  /**
   * Fetch drilled hole data
   * @param params - Query parameters (pattern, mine_code, planned_only)
   * @returns Promise resolving to drilled data response
   */
  getDrilledData: async (params: DrilledDataQueryParams): Promise<DrilledDataResponse> => {
    const response = await apiClient.get<DrilledDataResponse>('/drilled_data/', {
      params: { crs: 'local', ...params },
    });
    return response.data;
  },
};

export { drilledDataService };
